import React, { useEffect, useState } from 'react';

import {
  Pagination as DLSPagination, Button, Input, Alert, IconLeft,
  IconRight, dlsGray04, dlsBrightBlue,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

// eslint-disable-next-line complexity
const Pagination = ({ type, ...props }) => {
  const [inputValue, setInputValue] = useState(props.selected);

  useEffect(() => {
    setInputValue(props.selected);
  }, [props.selected]);

  const isValidInput = (value) => {
    const pageNumber = Number(value);
    return pageNumber <= props.total && pageNumber > 0;
  };
  const handleInputChange = (event) => {
    const { value } = event.target;
    setInputValue(value);
  };

  const handlePrevious = () => {
    props.onChange(props.selected - 1);
  };

  const handleNext = () => {
    props.onChange(props.selected + 1);
  };
  const handleSubmit = (e) => {
    if (isValidInput(inputValue) && e.key === 'Enter') {
      props.onChange(Number(inputValue));
    }
  };
  if (type === 'primary') {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <DLSPagination {...props} />;
  }
  const previousButtonText = props.previousText || 'Previous';
  const nextButtonText = props.previousText || 'Next';

  const previousButtonDisabled = isValidInput(inputValue) && props.selected <= 1;
  const nextButtonDisabled = isValidInput(inputValue) && props.selected >= props.total;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center',
    }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>

        <Button
          disabled={previousButtonDisabled}
          onClick={handlePrevious}
          theme={previousButtonDisabled ? dlsGray04 : dlsBrightBlue}
        >
          <IconLeft
            size="sm"
            theme={previousButtonDisabled ? dlsGray04 : dlsBrightBlue}
          />  {previousButtonText}
        </Button>
        <Input
          onKeyPress={handleSubmit}
          style={{ width: 50, marginLeft: 8, marginRight: 8 }}
          value={inputValue}
          onChange={handleInputChange}
          error={isValidInput(inputValue) ? 'default' : 'error'}
        />
        <div style={{ marginRight: 8 }}>of {props.total} {' '}</div>
        <Button
          disabled={nextButtonDisabled}
          onClick={handleNext}
          theme={nextButtonDisabled ? dlsGray04 : dlsBrightBlue}

        >
          { nextButtonText}
          <IconRight
            size="sm"
            theme={nextButtonDisabled ? dlsGray04 : dlsBrightBlue}
          />
        </Button>
      </div>
      {isValidInput(inputValue) ? null : <Alert>Enter a valid page number</Alert>}
    </div>
  );
};

Pagination.displayName = 'Pagination';

Pagination.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary']),
  ...DLSPagination.defaultProps,
};

export default Pagination;
